module.exports = __webpack_public_path__ + "img/224.electric_problem.dbc9ee7a.svg";